import { ActionTypes } from "../constants/action-types";

export const setDevelopmentData = (val) => {
  return {
    type: ActionTypes.SET_DEVELOPMENT_DATA,
    payload: val,
  };
};
